module.exports = __webpack_public_path__ + "img/任丘石油.144edefd.jpg";